<template>
  <aside>
    <!-- Sidebar -->
    <div class="sidebar">
      <div class="arrow-inner" @click="toggles()">
        <button
          class="border-0 bg-transparent sidebar__arrow"
          :class="{ active: !getMenuState }"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.3945 16.8477C20.7109 16.5312 20.7109 16.0039 20.3945 15.6875L13.5742 8.83203C13.2227 8.51562 12.6953 8.51562 12.3789 8.83203L11.5703 9.64062C11.2539 9.95703 11.2539 10.4844 11.5703 10.8359L16.9844 16.25L11.5703 21.6992C11.2539 22.0508 11.2539 22.5781 11.5703 22.8945L12.3789 23.7031C12.6953 24.0195 13.2227 24.0195 13.5742 23.7031L20.3945 16.8477Z"
              fill=""
            />
          </svg>
        </button>
        <span v-if="!getMenuState">Свернуть</span>
      </div>

      <!-- Sidebar Menu -->
      <tree-view :showMenu="showMenu" :nodes="menu" />
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import NavApi from "../../modules/admin/api/navigation";
import TreeView from "../ui/TreeView";
import refreshAuthorizationHeader from "../axios";
import userManager from "@/modules/auth/user-manager";

export default {
  name: "Sidebar",
  components: { TreeView },
  props: {
    showMenu: Boolean,
    toggleArrow: Boolean,
  },
  created() {
    setTimeout(() => {
      refreshAuthorizationHeader();
      this.loadMenu();
    }, 500);
  },
  data: () => ({
    menu: [],
  }),
  methods: {
    loadMenu() {
      NavApi.getTree()
        .then((response) => {
          this.menu = response.data.map((item) => {
            return {
              id: item.id,
              title: item.title,
              to: item.to === "/content/admin" ? "/admin" : item.to,
              icon: item.icon,
              items: item.items,
            };
          });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            userManager.signoutRedirect();
            localStorage.setItem("token", "");
            this.$router.push({ name: "Login" });
          }
        });
    },
    toggles() {
      this.$emit("collapse-toggle");
    },
  },
  computed: {
    getMenuState() {
      return this.$store.getters.getMenuState;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/assets/theme/default/colors";

.sidebar {
  height: 100%;
  padding: 0 12px !important;
}

.sidebar__arrow {
  margin-right: 16px;

  svg {
    fill: $white;
  }
}

.active {
  padding: 0;
  transform: rotate(180deg);
  color: $gray-medium;
  width: 22px;

  svg {
    fill: $gray-medium;
  }
}

.arrow-inner {
  margin-top: 32px;
  margin-bottom: 40px;
}

.dashboard-sidebar {
  overflow-y: auto !important;
}
</style>
